import { useMutation, useQuery } from "@tanstack/react-query"

import { accountActivationApi, type SetPasswordPayload } from "./api"
import { accountActivationKeys } from "./queryKeys"

/** GET the sanitized token context (recipient name, scope, masked email). */
export const useSetupTokenContext = (token: string | undefined) =>
  useQuery({
    queryKey: accountActivationKeys.context(token ?? ""),
    queryFn: () => accountActivationApi.getContext(token as string),
    enabled: !!token,
    // A 404/410/503 is terminal — retrying just burns the IP rate budget.
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
  })

/** POST the new password to activate the account. */
export const useSetPassword = (token: string) =>
  useMutation({
    mutationFn: (payload: SetPasswordPayload) => accountActivationApi.setPassword(token, payload),
  })

/** POST a password-reset request for an admin email (JWT-free; the backend
 *  always returns 200 to avoid account enumeration). */
export const useRequestPasswordReset = () =>
  useMutation({
    mutationFn: (email: string) => accountActivationApi.requestPasswordReset(email),
  })
